import React, { Component } from 'react';

import Dashboard from './DashboardComponent'
import { actions } from './DashboardReducer'
import { connect } from 'react-redux'

class Wrapper extends Component {
    componentDidMount() {
        this.props.fetch();
    }
    render() {
        return (
            <Dashboard {...this.props} />
        )
    }
}


const mapStateToProps = (state, ownProps) => {

    const groups = state.waas.dashboard.groups;
    // console.log(groups)
    // const hasAccessTo = (role) => {
    //     console.log(groups)
    //         debugger
    //         // Admin can see everything
    //         if(groups.includes('Admin')) return true;
    
    //         // Items with no markings are accessible to Technical Support and admins.
    //         if(role === null && (groups.includes('TechnicalSupport') || groups.includes('Admin'))){
    //             return true;
    //         }
    
    //         // Items marked [CS] are accessible to Customer Services and admins (NOT technical support).
    //         if(groups.includes('CustomerService') && groups.includes(role)){
    //             return true;
    //         }
    
    //         return false;
    // }

    return {
        loading: state.waas.dashboard.loading,
        availableIps: state.waas.dashboard.availableIps,
        under_maintenance: state.waas.dashboard.under_maintenance,
        items: state.waas.dashboard.aaaa,
        username: state.waas.dashboard.username,
        expiredAppsCount: state.waas.dashboard.expiredAppsCount,
        // hasAccessTo,
        groups: groups || []
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        fetch: (params) => {            
            dispatch(actions.fetchDashboard(params));
        },
        logout: () => {            
            dispatch(actions.logout())
        },              
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Wrapper)